const getArrayLabel = arr => `Array(${arr.length})`;

function convert(key, data) {
  if (data === undefined && data === null) {
    return { key, data, type: data };
  }

  const type = typeof data;
  if (Array.isArray(data)) {
    return {
      type: 'array',
      key,
      value: getArrayLabel(data),
      children: data.map((item, index) => convertComplexType(index, item)), // eslint-disable-line no-use-before-define
    };
  }
  if (type === 'object') {
    return {
      type,
      key,
      value: 'Object',
      children: data && Object.keys(data).map(item => convertComplexType(item, data[item])), // eslint-disable-line no-use-before-define
    };
  } else if (type === 'boolean') {
    return {
      key,
      type,
      value: data ? 'true' : 'false',
    };
  }
  return data;
}

function convertComplexType(key, item) {
  if (item !== undefined && item !== null) {
    const value = convert(key, item);
    const type = typeof value;

    return type === 'object' ? value : { key, value, type };
  }
  return { key, value: `${item}`, type: item === undefined ? 'undefined' : 'null' };
}

function getUniqueAttributeName(item) {
  let count = 0;
  let name;

  while(item[name = `name${count ? `-${count}` : ''}`] !== undefined) {
    ++count;
  }
  return name;
}

export function addItem(data, key, name, type) {
  const indexes = key.split('.').map(k => parseInt(k, 10)).slice(0, -1);
  const clone = clonePath(data, indexes);
  const index = indexes[indexes.length - 1];
  const parent = getItem(clone, indexes.slice(1, -1));
  let value;

  if (type === 'object') {
    value = {};
  } else if (type === 'array') {
    value = [];
  } else if (type === 'boolean') {
    value = false;
  } else if (type === 'string') {
    value = "empty";
  } else if (type === 'number') {
    value = 0;
  }
  if (Array.isArray(parent)) {
    parent.splice(index, 0, value);
  } else {
    parent[name] = value;
  }
  return clone;
}

export function addPlaceholder(data, key, expanded) {
  let indexes = key.split('.').map(k => parseInt(k, 10)).slice(0, -1);
  const changed = clonePathInternal(data, indexes);
  let item = getItem(changed, indexes, true);
  let index = 0;

  if (item.type === 'object') {
    index = item.children.length;
  } else if (item.type === 'array') {
    const tmp = key.split('.').map(k => parseInt(k, 10)).slice();
    index = expanded ? tmp[tmp.length - 1] + 1 : 0;
  } else {
    return addPlaceholder(data, indexes.join('.'), expanded);
  }
  item.children = item.children.slice();
  item.children.splice(index, 0, {
    key: item.type === 'array' ? 0 : getUniqueAttributeName(item),
    type: 'unknown-type',
  });
  if (item.type === 'array') {
    item.value = getArrayLabel(item.children);
    item.children.forEach((item, index) => (item.key = index));
  }
  return changed;
}

export function clonePath(data, indexes) {
  let copy = data;
  const index = indexes[0];
  let key = index;

  if (Array.isArray(data)) {
    copy = data.slice();
  } else if (typeof data === 'object') {
    copy = { ...data };
    key = Object.keys(data)[index];
  }
  if (indexes.length > 1) {
    copy[key] = clonePath(copy[key], indexes.slice(1));
  }
  return copy;
}

export function clonePathInternal(data, indexes) {
  let copy = data;
  const index = indexes[0];
  let key = index;

  if (Array.isArray(data)) {
    copy = data.slice();
  } else if (typeof data === 'object') {
    copy = {
      ...data,
    };
    if (data.children) {
      copy.children = data.children.slice();
      copy.children[index] = clonePathInternal(copy.children[index], indexes.slice(1));
      return copy;
    }
  }
  if (indexes.length > 1) {
    copy[key] = clonePathInternal(copy[key], indexes.slice(1));
  }
  return copy;
}

export function deleteItem(data, key) {
  const indexes = key.split('.').map(k => parseInt(k, 10)).slice(1, -1);
  const index = indexes[indexes.length - 1];
  const changed = clonePath(data, indexes);
  const parent = getItem(changed, indexes.slice(0, -1));

  if (Array.isArray(parent)) {
    parent.splice(index, 1);
  } else {
    const name = Object.keys(parent)[index];

    delete parent[name];
  }
  return changed;
}

export function getItem(data, indexes, internal) {
  let item = data;

  if (indexes) {
    for (let i = 0; i < indexes.length; i++) {
      if (Array.isArray(item)) {
        item = data[indexes[i]];
      } else if (typeof item === 'object') {
        if (internal) {
          item = item.children[indexes[i]];
        } else {
          const name = Object.keys(item)[indexes[i]];

          item = item[name];
        }
      }
    }
  }
  return item;
}

export function updateKey(data, key, oldKey, newKey) {
  const indexes = key.split('.').map(k => parseInt(k, 10)).slice(1, -2);
  const changed = clonePath(data, indexes);
  const item = getItem(changed, indexes);

  if (newKey !== oldKey) {
    item[newKey] = item[oldKey];
    delete item[oldKey];
  }
  return changed;
}

export function updateValue(data, key, name, value) {
  const indexes = key.split('.').map(k => parseInt(k, 10)).slice(1, -2);
  const changed = clonePath(data, indexes);
  const parent = getItem(changed, indexes);
  const type = typeof parent[name];
  let val = value;

  if (type === 'boolean') {
    val = value === 'true';
  } else if (type === 'number') {
    val = value.indexOf('.') >= 0 ? parseFloat(value, 10) : parseInt(value, 10);
  }
  parent[name] = val;
  return changed;
}

export function convertJsonToTree(data) {
  return convert(undefined, data);
}
